declare const __APP_VERSION__: string;
declare const __APP_BUILD_TIME__: string;

export function VersionTag() {
  const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
  const buildTime = typeof __APP_BUILD_TIME__ !== 'undefined' ? __APP_BUILD_TIME__ : 'unknown';
  return (
    <span className="version-tag" title={`Build ${version} · ${buildTime}`}>
      v{version}
    </span>
  );
}
